import React from "react";

export function StatCard({ label, value, sub, accent = "forest" }) {
  return (
    <div className="card-academic p-6">
      <div className="overline mb-2">{label}</div>
      <div className={`font-mono font-semibold text-4xl ${accent === "terracotta" ? "text-terracotta" : "text-forest"}`}>{value}</div>
      {sub && <div className="text-xs text-mossy mt-2">{sub}</div>}
    </div>
  );
}

export function PageHeader({ eyebrow, title, subtitle, actions }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 mb-8">
      <div>
        {eyebrow && <div className="overline mb-2">{eyebrow}</div>}
        <h1 className="font-serif text-4xl md:text-5xl text-forest leading-tight">{title}</h1>
        {subtitle && <p className="text-sm text-mossy mt-2 max-w-2xl">{subtitle}</p>}
      </div>
      {actions}
    </div>
  );
}

export function Section({ title, children, right }) {
  return (
    <section className="mb-10">
      {(title || right) && (
        <div className="flex items-center justify-between mb-4">
          {title && <h3 className="font-serif text-2xl text-forest">{title}</h3>}
          {right}
        </div>
      )}
      {children}
    </section>
  );
}

export function EmptyState({ title = "Nothing here yet", body }) {
  return (
    <div className="card-academic p-10 text-center">
      <div className="font-serif text-2xl text-forest mb-2">{title}</div>
      {body && <p className="text-sm text-mossy">{body}</p>}
    </div>
  );
}
